export default __webpack_public_path__ + "static/media/n2.9d04f5d2.jpg";